export enum NoDataDisplayStateEnum {
  Show = 1,
  Hide,
}
